import { Struct } from 'shoteyes-types';
import { Block } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { service } from '../service';
import { SelectStyleEnum } from '../types';
import type { ReactElement } from 'react';
import type { CheckBoxProps } from './types';

export function CheckBoxComponent(props: CheckBoxProps): ReactElement {
  const { max, value } = props;

  const onChange = (values: string[]): void => {
    if (max != null && values.length > max) {
      return;
    }

    props.onPropsChange?.({ value: values });
  };

  // 考试单独特殊显示
  if (props?.formType === Struct.FormType.ANSWER) {
    return (
      <div className={styles.mb10}> {
        (props?.option ?? [])?.map((row, index) => (
          <Base.Row key={index}>
            <Base.Col span={12} key={`${row.value}_${row.title}`}>
              <div>{row.value}.{row.title}</div>
            </Base.Col>
          </Base.Row>
        ))}
      </div>
    );
  }

  return (
    <Base.Checkbox.Group value={value} className={styles.radioGroup} onChange={onChange}>
      <Block if={props.selectStyle === SelectStyleEnum.GRID}>
        {service.splitArray((props.option ?? []), 2).map((row, index) => (<Base.Row key={index}>
          {
            row.map(col => (
              <Base.Col span={12} key={`${col.value}_${col.title}`}>
                <Base.Checkbox value={col.value}>{col.title}</Base.Checkbox>
              </Base.Col>
            ))
          }
        </Base.Row>))}
      </Block>
      <Block if={[SelectStyleEnum.LINE, SelectStyleEnum.LIST].includes(props.selectStyle)}>
        <Base.Space direction={props.selectStyle === SelectStyleEnum.LIST ? 'vertical' : 'horizontal'} wrap>
          {(props.option ?? []).map(item => (
            <Base.Checkbox value={item.value} key={`${item.title}_${item.value}`}>
              {item.title}
            </Base.Checkbox>
          ))}
        </Base.Space>
      </Block>
      <Block if={props.selectStyle == null}>
        <Base.Space direction='horizontal' wrap>
          {(props.option ?? []).map(item => (
            <Base.Checkbox value={item.value} key={`${item.title}_${item.value}`}>
              {item.title}
            </Base.Checkbox>
          ))}
        </Base.Space>
      </Block>
    </Base.Checkbox.Group>
  );
}
